const OwnMsgBubble = ({ text, nextDifferent }) => (
  <div className={`own-msg-container-text ${nextDifferent ? "last" : ""}`}>
    <wb-text>{text}</wb-text>
  </div>
);

export default OwnMsgBubble;
